<template>
    <div class="my-2 pt-2 pb-3 flex justify-between items-center border-b">
        <div class="flex">
            <p class="flex items-center text-sm text-gray-500">
                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" :class="topic.style">
                        {{ $t("states." + topic.state) }}
                    </span>
            </p>
        </div>

        <div class="flex">
            <button type="button" class="flex items-center text-sm text-gray-500"
                    @click="$inertia.visitInModal(route(editStateRoute, {topic: topic.uuid}))">
                <TagIcon class="mr-2 h-5 w-5 text-minplan-darkgreybeige" />
                <span class="hidden md:flex ml-1">
                        {{ $t("projects.stateChange") }}
                    </span>
            </button>

        </div>
    </div>
</template>

<script>
import { TagIcon } from "@heroicons/vue/outline";

export default {
    props: ['topic', 'editStateRoute'],
    components: {
        TagIcon
    }
};
</script>

<style scoped>

</style>
